import { environment } from '@environments/environment';

const Constants = {
  general: {
    defaultPictureWidth: 150,
    defaultPictureRatio: 0.66,
    padding: 100,
    minCanvasWidth: 1000,
    minCanvasHeight: 600,
    maxConcurrentDownloads: 5,
    fontFamily: 'Roboto,sans-serif',
  },
  topics: {
    showPicture: true,
    minFontSize: 13,
    maxFontSize: 27,
    showPanel: true,
    showBorder: true,
    scaleFactorCircle: 20,
  },
  groupedDocuments: {
    show: true,
    showLabel: true,
    characterWidth: 10,
    fontSize: 5,
    minDocumentsPerGroup: 7, //minimum number of Documents per group
  },
  thresholds: {
    //Visibility and transitions between layers
    documentPoints: [2, 4],
    keywordLabel: [2, 3.7],
    topic: [0, 0.46],
    subTopic: [0.66, 1.8],
    groupedDocuments: [0.66, 1.8],
    documentCard: [4],
    documentTitle: [4],
  },
  wordElement: {
    fadeInDurationWordElement: 1000,
    fadeOutDurationWordElement: 100,
    maxWordElementsInViewPoirt: 200,
    placeholderWordElements: false, //draw placeholders for word elements that cannot be shown
    showPicturesForWords: false, //whether a given picture for a word is displayed
    paddingByLevel: {
      0: 15,
      1: 10,
      2: 15,
      3: 20,
    },
    fontSizeByWodLevel: {
      0: 25,
      1: 20,
      2: 15,
      3: 15,
    },
    colorByWordLevel: {
      0: '#444',
      1: '#999',
      2: '#aaa',
      3: '#aaa',
    },
    boldByWordLevel: {
      0: true,
      1: true,
      2: false,
      3: false,
    },
    showPanelByWordLevel: {
      0: true,
      1: true,
      2: true,
      3: true,
    },
    panelColorByWordLevel: {
      0: '#fff',
      1: '#fff',
      2: '#fff',
      3: '#fff',
    },
  },
  kmeansClustering: {
    //kmeans Clustering (plotting words into cluster)
    showWords: true,
    showTopics: false,
    showSubTopics: false,
    showGroupedDocuments: true,
    showGroupedDocumentLabels: true,
  },
  subTopics: {
    show: false,
    maxLines: 1,
    fontSize: 10.6,
    minCount: 2,
    maxCount: 8,
    maxStringLength: 15,
    shadowBlur: 2,
  },
  keywordLabels: {
    sampleRate: 0.25, //percentage how likeli keyword label is presented (0.25 => on average ever 4th~ document is presented with keyword label)
    fontSize: 3.5,
    maxCharacterLength: 20,
  },
  animations: {
    enable: false,
    durationCircleSelect: 200,
    durationCircleUnselect: 200,
  },
  zoom: {
    // ZOOM BEHAVIOUR
    min: 0.8,
    max: 10.5,
    maxSteps: 10,
    zoomTransitionTime: 500,
    threshold: 0,
    zoomButtonIncrement: 2,
  },
  selection: {
    eventtypeSelect: null, // mouseover, click
    eventTypeUnselect: null,
    highlightDocumentsOnSelect: true,
    scaleFactorSelection: 1.1,
  },
  documentPoint: {
    width: 20,
    scaleFactor: 0.8,
    border: 1,
    fontSize: 1.3,
    pictureWidth: 10,
    pictureHeight: 6,
    borderWidthBottom: 5,
    shadowBlur: 2,
    countImagePreview: 1, // specifies the number of pictures that are shown as preview for each document (only 1 or 3 can be used for layout reasons)
    defaultPicture: `${environment.assetsUrl}/image/default_idea_thumbnail.png`,
    minRatioDocumentPicture: 0.8, //heigt to width ratio
    maxRatioDocumentPicture: 1.1, //height to width ratio
  },
  grid: {
    offset: 1.6,
    width: 0.05,
    color: '#d7d7d7',
  },
  forceLayout: {
    maxIterations: 100,
    thresholdAlpha: 0.0,
    areaPerDocument: 10 * 10,
    collisionRadiusFactor: 0.3, //determines the 'shape' of the layout. Values between 0.2 and 0.4 work well (the smaller, the more original structure and contour is preserved)
  },
};

export default Constants;
